/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_CopyInputs */

const vi_api_keys_copy = /** @type {(inputs: Api_Keys_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sao chép`)
};

/**

* @param {Api_Keys_CopyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_copy = /** @type {((inputs?: Api_Keys_CopyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_CopyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_copy(inputs)
});